import React, { useContext, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

import { UserContext } from "./UserContext";
import "./Register.css";

const Register = () => {
  const navigate = useNavigate();
  const { login } = useContext(UserContext);

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        "https://wholeness-forward.onrender.com/api/auth/register",
        {
          username,
          email,
          password,
        },
        {
          withCredentials: true,
        },
      );

      const { token, id, username: registeredUsername } = response.data;

      if (!token || !id || !registeredUsername) {
        throw new Error(
          "Registration succeeded, but login information was missing.",
        );
      }

      localStorage.setItem("token", token);

      login({
        username: registeredUsername,
        id,
        token,
      });

      navigate("/");
    } catch (err) {
      console.error("Registration failed:", err);

      setError(
        err.response?.data?.error ||
          err.response?.data?.message ||
          "Failed to register. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <h1 className="register-title">Register</h1>

      {error && <div className="error-message">{error}</div>}

      <form className="register-form" onSubmit={handleSubmit}>
        <div className="input-container">
          <label htmlFor="username" className="input-label">
            Username
          </label>

          <input
            id="username"
            type="text"
            placeholder="Enter your username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            className="register-input"
          />
        </div>

        <div className="input-container">
          <label htmlFor="email" className="input-label">
            Email
          </label>

          <input
            id="email"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="register-input"
          />
        </div>

        <div className="input-container">
          <label htmlFor="password" className="input-label">
            Password
          </label>

          <input
            id="password"
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            className="register-input"
          />
        </div>

        <div className="input-container">
          <label htmlFor="confirmPassword" className="input-label">
            Confirm Password
          </label>

          <input
            id="confirmPassword"
            type="password"
            placeholder="Confirm your password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            minLength={6}
            className="register-input"
          />
        </div>

        <button type="submit" className="button" disabled={loading}>
          {loading ? "Creating account..." : "Register"}
        </button>
      </form>

      <p className="login-note">
        Already have an account?{" "}
        <Link to="/login" className="link">
          Log in here
        </Link>
        .
      </p>
    </div>
  );
};

export default Register;
